<template>
  <v-container
    class="progress-goalSetting-behaviourChangeGoals pb-8"
    v-disable-all="hasReadOnlyAccess"
  >
    <v-row>
      <v-col cols="2" offset-sm="3" align="center" class="pr-6 mt-2">
        <h3>{{ $t("journeyBehaviourChangeGoals.status") }}</h3>
      </v-col>
      <v-col class="mt-2 col-xs-7 col-xl-1 justify-xl-center d-flex text-center">
        <h3>{{ $t("dummy.outcomeGoals.outcomeGoal") }}</h3>
      </v-col>
      <!-- <v-col cols="1" align="center">
        {{ $t("journeyOutcomeGoals.reviewReminders") }}
      </v-col> -->
    </v-row>

    <goal-setting-outcome-goal-row
      v-for="outcomeGoal in outcomeGoals.items"
      :key="outcomeGoal.key"
      :outcomeGoal="outcomeGoal.key"
      :icon="outcomeGoalsIcons[outcomeGoal.key]"
      :label="outcomeGoalsLabels[outcomeGoal.key]"
      :status="{ value: outcomeGoal.value, label: statusLabels[outcomeGoal.value] || $t('journeyOutcomeGoals.undefined'), color: outcomeGoal.color, }"
      :extraInformation="outcomeGoal.extraInformation"
    />
    <unsaved-changes-warning
      ref="unsavedChangesWarning"
      :targetScreensToSkip="['PatientOverview']"
    ></unsaved-changes-warning>
  </v-container>
</template>

<script>
import GoalSettingOutcomeGoalRow from "../../../components/Parts/GoalSettingOutcomeGoalRow.vue";
import UnsavedChangesWarning from "../../../components/Parts/UnsavedChangesWarning.vue";
import { mapGetters } from "vuex";

/**
 * Component ProgressGoalSettingOutcomeGoals.vue
 *
 * @module ProgressGoalSettingOutcomeGoals
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.5] app/src/APP_DASHBOARD/templates/views/Patient/Progress/ProgressGoalSettingOutcomeGoals.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "ProgressGoalSettingOutcomeGoals",
  props: {
    outcomeGoal: {
      type: String,
    },
    icon: {
      type: String,
    },
    status: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      patientId: "patientSummary/id",
      outcomeGoals: "patientSummary/outcomeGoals",
      unsavedChanges: 'patientSummary/unsavedChanges',
      hasReadOnlyAccess: "user/hasReadOnlyAccess"
    }),
  },
  created() {},
  data: function () {
    return {
      outcomeGoalsIcons: {
        LOWERING_BLOOD_PRESSURE: "icon-blood-pressure",
        HEALTHY_WEIGHT: "icon-weight",
        LOWERING_CHOLESTEROL: 'icon-cholesterol-ldl',
        DIABETES_MANAGEMENT: "icon-glucose",
      },
      outcomeGoalsLabels: {
        LOWERING_BLOOD_PRESSURE: this.$stripHTML(this.$ucfirst(this.$t("screens.loweringBloodPressureSettingScreen", {catalog: "app_mobile"}))),
        HEALTHY_WEIGHT: this.$stripHTML(this.$ucfirst(this.$t("screens.healthyWeightSettingsScreen", {catalog: "app_mobile"}))),
        LOWERING_CHOLESTEROL: this.$stripHTML(this.$ucfirst(this.$t("screens.loweringCholesterolSettingScreen", {catalog: "app_mobile"}))),
        DIABETES_MANAGEMENT: this.$stripHTML(this.$ucfirst(this.$t("screens.diabetesManagementSettingScreen", {catalog: "app_mobile"}))),
      },
      statusLabels: {
        poor: this.$stripHTML(this.$ucfirst(this.$t("questionnaires.MY_SLEEP.questions.CAT_POOR", {catalog: "questionnaires"}))),
        moderate: this.$stripHTML(this.$ucfirst(this.$t("expertTool.intensity.M.long"))),
        good: this.$stripHTML(this.$ucfirst(this.$t("questionnaires.MY_SLEEP.questions.CAT_GOOD", {catalog: "questionnaires"}))),
      }
    };
  },
  watch: {},
  components: {
    GoalSettingOutcomeGoalRow,
    UnsavedChangesWarning
  },
  beforeRouteLeave(to, from, next) {
    if (this.unsavedChanges()) {
      this.$refs.unsavedChangesWarning.prepareToExit(to.name)
      return false;
    }
    next();
  }
};
</script>

<style lang="scss">
</style>